export const app = {
  /* Before Login */
  first: "/",
  register: "/cadastro",
  login: "/login",
  forgotPassword: "/esqueceu-senha",
  recoverPassword: (token: string) => `/recuperar-senha/${token}`,
  membership: (token: string) => `/formulario-adesao/${token}`,
  unauthorized: "/unauthorized",

  /* After Login */
  auth: "/auth",
  authStepUp: "/auth/step-up", // new
  home: "/inicio",
  security: "/seguranca", // new
  kyc: "kyc",
  pld: "pld",
  //  CryptoTech
  registerOrders: "/register-orders",
  bank: "/bank",
  users: "/users",
  documentsGenerator: "/generator-documents",
  convert: "/convert",
};
